import { Spin } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { checkPartnerToken, setForceRefresh, checkToken } from '../actions/auth'
import { TAG_KEY } from '../constants/local-storage-keys'
import { calcESTDay, getDayKeyFromDate } from '../sagas/lineup'
import { api_token, api_id } from '../constants/partner'

class Initializer extends Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search)
    let token = params.get('token') || api_token
    let user_id = params.get('id') || api_id

    this.props.checkPartnerToken(token, user_id)
    // Set up local tag storage on init
    const dateKey = getDayKeyFromDate(calcESTDay())
    const savedTags = JSON.parse(localStorage.getItem(TAG_KEY))
    if (!savedTags || savedTags.date !== dateKey) localStorage.setItem(TAG_KEY, JSON.stringify({
      date: dateKey
    }))

    // set force refresh for 24 hours
    setTimeout(() => {
      this.props.setForceRefresh()
    }, 1000 * 60 * 60 * 33)
    // setTimeout(() => {
    //   this.props.setForceRefresh()
    // }, 1000)
  }

  render() {
    if (this.props.auth.loadingCheck) {
      return (
        <div style={{marginTop: '400px', textAlign: 'center'}}>
          <Spin />
        </div>
      )

    }
    return (
      <div>{ this.props.children }</div>
    )
  }
}

export default connect(
  state => ({
    auth: state.auth
  }),
  {
    checkToken: checkToken,
    checkPartnerToken: checkPartnerToken,
    setForceRefresh: setForceRefresh
  }
)(Initializer)
